export enum DeviceOperatingSystem {
  iPhone = 'iPhone OS',
}
